import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import { debounce, isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import adminAPi from "../../../utils/adminAPi";
import { FeAutocomplete } from "../../FormElements";
import FeTextField from "../../FormElements/FeTextField";

const ResponseForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [formValue, setFormValue] = useState({
    target_lasion: null,
    non_target_lasion: null,
    new_lasion: null,
    result: null,
    type: "Clinical",
  });
  const options = [
    {
      label: "RECIST 1.1",
      value: "Clinical",
    },
    {
      label: "iRECIST",
      value: "Radiological",
    },
    {
      label: "Pathological",
      value: "Pathological",
    },
  ];
  const [type, setType] = useState(options[0]);
  const [errors, setErrors] = useState({});
  const [errorMsg, setErrorMsg] = useState("");
  useEffect(() => {
    if (id) {
      getDetails(id);
    }
  }, []);
  function convertEmptyStringToNull(obj) {
    const newObj = {};

    for (let key in obj) {
      newObj[key] = obj[key] === "" ? null : obj[key];
    }

    return newObj;
  }
  async function getDetails(id) {
    const { data } = await adminAPi.get(
      `admin/response-rate-calculation-records/${id}`
    );
    setFormValue(data.data);
    setType(options.find((o) => o.value === data.data.type));
  }

  const handleField = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFormValue({ ...formValue, [name]: value });
  };

  const handleSubmit = async (e) => {
    const updatedData = convertEmptyStringToNull(formValue);
    e.preventDefault();
    try {
      setErrors({});
      setErrorMsg("");
      if (id) {
        console.log("AAAA", updatedData);
        const { data } = await adminAPi.put(
          `admin/response-rate-calculation-records/${id}`,
          updatedData
        );
        navigate(pathname.substring(0, pathname.lastIndexOf("/")));
      } else {
        console.log("AAAA", updatedData);
        const { data } = await adminAPi.post(
          "admin/response-rate-calculation-records",
          updatedData
        );
        navigate(pathname.substring(0, pathname.lastIndexOf("/")));
      }
    } catch ({ response }) {
      console.log(response);
      if (response) {
        const { data } = response;
        if (data && data.errors) {
          setErrors(data.errors);
        }

        if (data && data.message) {
          setErrorMsg(data.message);
        }
      }
    }
  };

  return (
    <Card sx={{ mt: 2 }}>
      <CardContent>
        <Grid container spacing={1}>
          <Grid item sm={4}>
            <FeTextField
              name="target_lasion"
              id="T"
              label="target_lasion"
              value={formValue.target_lasion ? formValue.target_lasion : ""}
              onChange={handleField}
            />
          </Grid>
          <Grid item sm={4}>
            <FeTextField
              name="non_target_lasion"
              id="N"
              label="non_target_lasion"
              value={
                formValue.non_target_lasion ? formValue.non_target_lasion : ""
              }
              onChange={handleField}
            />
          </Grid>
          <Grid item sm={4}>
            <FeTextField
              name="new_lasion"
              id="M"
              label="new_lasion"
              value={formValue.new_lasion ? formValue.new_lasion : ""}
              onChange={handleField}
            />
          </Grid>
          <Grid item sm={4}>
            <FeTextField
              name="result"
              id="result"
              label="Result"
              value={formValue.result ? formValue.result : ""}
              onChange={handleField}
            />
          </Grid>
          <Grid item sm={4}>
            <FeAutocomplete
              getOptionLabel={(option) => option.label}
              onChange={(e, v) => {
                // handleChangeInput("gender", v);
                setType(v);
                setFormValue({ ...formValue, type: v.value });
              }}
              value={type}
              options={options}
              disableClearable
              label="Type"
            />
          </Grid>
        </Grid>

        <Box
          display="flex"
          justifyContent="flex-start"
          flexDirection={"column"}
          mt={2}
        >
          {!isEmpty(errors) && (
            <>
              {Object.keys(errors).map((o, j) => {
                return (
                  <Typography
                    key={j}
                    variant="subtitle2"
                    gutterBottom
                    sx={{ color: "red" }}
                  >
                    {errors[o][0]}
                  </Typography>
                );
              })}
            </>
          )}
          {!isEmpty(errorMsg) && (
            <Typography variant="subtitle2" gutterBottom sx={{ color: "red" }}>
              {errorMsg}
            </Typography>
          )}
        </Box>
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button type="submit" variant="contained" onClick={handleSubmit}>
            Submit
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};
export default ResponseForm;
